import { jsPDF } from "jspdf";
import "jspdf-autotable";
import * as XLSX from 'xlsx';

export const reportService = {
  /**
   * Prepares common data structure for reporting
   */
  prepareData: (bookings) => {
    const headers = ['Booking ID', 'Created At', 'Booking Date', 'Booking Time', 'Status', 'Payment', 'Amount (LKR)'];
    const rows = bookings.map(b => [
      b.id.slice(0, 8).toUpperCase(),
      new Date(b.created_at).toLocaleDateString(),
      b.booking_date,
      b.booking_time,
      b.status.toUpperCase(),
      (b.payment_status || 'pending').toUpperCase(),
      b.total_price
    ]);
    return { headers, rows };
  },

  /**
   * Generates and downloads an Excel file
   */
  exportToExcel: (bookings, fileName = 'BookOTG_Report') => {
    const { headers, rows } = reportService.prepareData(bookings);
    
    // Create worksheet
    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    
    // Create workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Bookings");
    
    // Auto-size columns
    const colWidths = headers.map((h, i) => {
      const maxLen = Math.max(
        h.length,
        ...rows.map(row => row[i]?.toString().length || 0)
      );
      return { wch: maxLen + 2 };
    });
    worksheet['!cols'] = colWidths;

    // Download
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  },

  /**
   * Generates and downloads a PDF file
   */
  exportToPDF: (bookings, title = 'Platform Bookings Report', fileName = 'BookOTG_Report') => {
    const { headers, rows } = reportService.prepareData(bookings);
    const doc = new jsPDF();

    // Add Branding & Title
    doc.setFontSize(22);
    doc.setTextColor(0, 71, 255); // Brand Primary Blue
    doc.text("BookOTG", 14, 20);
    
    doc.setFontSize(12);
    doc.setTextColor(100);
    doc.text(title, 14, 30);
    doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, 38);

    // Create Table
    doc.autoTable({
      head: [headers],
      body: rows,
      startY: 45,
      theme: 'striped',
      headStyles: { fillColor: [0, 71, 255], textColor: 255, fontStyle: 'bold' },
      alternateRowStyles: { fillColor: [245, 247, 255] },
      margin: { top: 45 },
      styles: { fontSize: 8, cellPadding: 3 }
    });

    // Add Footer
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(8);
      doc.setTextColor(150);
      doc.text(
        `Page ${i} of ${pageCount} - Managed by Fesy Marketing Pvt Ltd`,
        doc.internal.pageSize.getWidth() / 2,
        doc.internal.pageSize.getHeight() - 10,
        { align: 'center' }
      );
    }

    doc.save(`${fileName}.pdf`);
  }
};